import { render, staticRenderFns } from "./TiktokAds.vue?vue&type=template&id=33f876fc&scoped=true&"
import script from "./TiktokAds.vue?vue&type=script&lang=js&"
export * from "./TiktokAds.vue?vue&type=script&lang=js&"
import style0 from "./TiktokAds.vue?vue&type=style&index=0&id=33f876fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f876fc",
  null
  
)

export default component.exports